import React, {Proptype, Component} from 'react'
import classnames from 'classnames'
import {connect} from 'react-redux'
import { Table } from 'components/UI'
import {browserHistory} from 'react-router'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import ClassOneNameTd from './ClassOneNameTd'
import ClassOneDateTd from './ClassOneDateTd'
import ClassOneStatusTd from './ClassOneStatusTd'
import ClassOneTeacherListTd from './ClassOneTeacherListTd'
import HadLessonTd from './HadLessonTd'
import __R from 'containers/__R';

const CONTROLLER_WIDTH = '14%'

const mapStateToProps = (state) => ({

})

class ClassOneTable extends Component {
  constructor(props){
    super(props)
  }

  render(){
    let {
      tableData,
      dispatch,
      settings,
      pagination,
      onPageChange,
      onItemsCountPerPageChange,
      fetching
    } = this.props

    const fields = [
      {
        name: 'className',
        title: __('Class Name', 'class'),
        getTdProps: ({tbodyData})=>{
          return {
            className: "class-info",
            style: {
              width: "15%"
            }
          }
        },
        getTdContent: ({ trData: classInfo })=>{
          //return <span />
          return (
           <ClassOneNameTd classInfo={classInfo} />
          )
        },
      },
      {
        name: 'earliest_day',
        title: __('Date', 'class'),
        getTdContent: ({ trData: classInfo })=>{
          //return <span />
          return <ClassOneDateTd classInfo={classInfo} />
        },
      },
      {
        name: 'totalQuantity',
        title: __('Lesson Status', 'class'),
        getTdContent: ({ trData: classInfo })=>{
          //return <span />
          return <ClassOneStatusTd classInfo={classInfo} />
        },
      },
      {
        name: 'teacherCount',
        title: __('Teachers', 'class'),
        getTdContent: ({ trData: classInfo })=>{
          //return <span />
          return <ClassOneTeacherListTd classInfo={classInfo} />
        },
      },
      {
        name: 'studentName',
        title: __('Students', 'class'),
        getTdProps: ({tbodyData})=>{
          return {
            className: "class-info",
            style: {
              width: "10%"
            }
          }
        },
        getTdContent: (opts)=>{
          if (opts.tdData) {
            let plusSign = '';
            if (opts.trData.studentCount > 1) {
              plusSign = ` (+${opts.trData.studentCount - 1})`;
            }

            return `${opts.tdData}${plusSign}`;
          } else { 
            return '';
          }
        },
      },
      {
        name: 'has_lesson',
        title: __('Status', 'class'),
        getTdContent: ({ trData: classInfo })=>{
          //return <span />
          return <HadLessonTd classInfo={classInfo} />
        },
      }
    ]

    return(
      <Table
        data={tableData}
        fields={fields}
        className='teacher-table'
        settingThTitle={__('Settings', 'class', null, true)}
        settingWidth={CONTROLLER_WIDTH}
        settings={settings}
        useMultiSelection={false}
        oneSettingPerRow={false}
        dropdownGuideWidth={160}
        dropdownGuideHeight={228}
        fetching={fetching}

        pagination={pagination}
        usePagination={true}
        onPageChange={onPageChange}
        onItemsCountPerPageChange={onItemsCountPerPageChange}
      />
    )
  }
}


export default connect(mapStateToProps)(ClassOneTable)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassOne/ClassOneTable/index.js